import { useCallback, useEffect } from "react"

export default function useSelectStartReset() {
    const onSelectStartReset = useCallback((event: Event) => {
        event.preventDefault()
        return false
    }, [])

    const initSelectReset = useCallback((e: KeyboardEvent) => {
        if (e.shiftKey) {
            document.addEventListener("selectstart", onSelectStartReset)
        }
    }, [onSelectStartReset])

    const destroySelectReset = useCallback((e?: KeyboardEvent) => {
        if (!e || e.shiftKey) {
            document.removeEventListener("selectstart", onSelectStartReset)
        }
    }, [onSelectStartReset])

    useEffect(() => {
        document.addEventListener("keydown", initSelectReset)
        document.addEventListener("keyup", destroySelectReset)
        return () => {
            document.removeEventListener("keydown", initSelectReset)
            document.removeEventListener("keyup", destroySelectReset)
            destroySelectReset()
        }
    })
}
